"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserFeedback = void 0;
const common_1 = require("@bugfender/common");
const utils_1 = require("./utils");
const issue_1 = require("./types/issue");
const user_feedback_scss_1 = __importDefault(require("./templates/user-feedback.scss"));
const user_feedback_html_1 = __importDefault(require("./templates/user-feedback.html"));
class UserFeedback {
    constructor(commands) {
        this.commands = commands;
        this.optionsValidator = new common_1.UserFeedbackOptionsValidator();
    }
    cancel() {
        this.resolve({ isSent: false });
        this.close();
    }
    close() {
        this.backdropEl.removeEventListener('click', this.closeCb);
        this.closeEl.removeEventListener('click', this.closeCb);
        this.formEl.removeEventListener('submit', this.submitCb);
        this.backdropEl = null;
        this.closeEl = null;
        this.feedbackEl = null;
        this.formEl = null;
        this.subjectEl = null;
        this.submitEl = null;
        this.titleEl = null;
        this.shadow.innerHTML = '';
        this.wrapperEl.innerHTML = '';
        this.wrapperEl.remove();
        this.wrapperEl = null;
    }
    injectCSS() {
        const style = document.createElement('style');
        style.textContent = user_feedback_scss_1.default.toString();
        this.shadow.append(style);
    }
    resolve(result) {
        this.deferred.resolve(result);
        this.deferred = null;
    }
    show(options) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.deferred) {
                return;
            }
            this.options = this.optionsValidator.init(options);
            this.deferred = (0, utils_1.createDeferred)();
            this.showModal();
            this.injectCSS();
            return this.deferred.promise;
        });
    }
    showModal() {
        this.wrapperEl = document.createElement('div');
        this.shadow = this.wrapperEl.attachShadow({ mode: 'closed' });
        this.shadow.innerHTML = user_feedback_html_1.default;
        this.titleEl = this.shadow.querySelector('[data-bf-title]');
        this.titleEl.innerText = this.options.title;
        if (this.options.hint) {
            this.hintEl = this.shadow.querySelector('[data-bf-hint]');
            this.hintEl.innerText = this.options.hint;
            this.hintEl.classList.remove('bf-modal__hint--hidden');
        }
        this.subjectEl = this.shadow.querySelector('[data-bf-subject]');
        this.subjectEl.setAttribute('placeholder', this.options.subjectPlaceholder);
        this.feedbackEl = this.shadow.querySelector('[data-bf-feedback]');
        this.feedbackEl.setAttribute('placeholder', this.options.feedbackPlaceholder);
        this.submitEl = this.shadow.querySelector('[data-bf-submit]');
        this.submitEl.innerText = this.options.submitLabel;
        this.closeCb = () => this.cancel();
        this.backdropEl = this.shadow.querySelector('[data-bf-backdrop]');
        this.backdropEl.addEventListener('click', this.closeCb);
        this.closeEl = this.shadow.querySelector('[data-bf-close]');
        this.closeEl.addEventListener('click', this.closeCb);
        this.formEl = this.shadow.querySelector('[data-bf-form]');
        this.submitCb = (e) => this.submit(e);
        this.formEl.addEventListener('submit', this.submitCb);
        const body = document.querySelector('body');
        body.appendChild(this.wrapperEl);
    }
    submit(e) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            e.stopPropagation();
            const feedbackURL = yield this.commands.addIssue(issue_1.IssueType.Feedback, this.subjectEl.value, this.feedbackEl.value);
            this.resolve({ isSent: true, feedbackURL });
            this.close();
        });
    }
}
exports.UserFeedback = UserFeedback;
